/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModeloCuentaMS { 
    secuencial?: number;
    codigo?: string;
    tipoCuenta?: string;
    moneda?: string;
    alias?: string;
    estado?: string;
    saldoRetencion?: number;
    saldoBloqueos?: number;
    saldoOtros?: number;
    saldo?: number;
    saldoDisponible?: number|null;
    encaje?: number;
    permiteTransaccionOperativa?: boolean;
    permiteDebito?: boolean;
    permiteCredito?: boolean;
}